<template>
  <custom-dialog class="location-item-dialog" :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
        <el-row>
          <el-col>
            <el-form-item :label="$t('device_projectName_dialog.xiang_mu_lian_xi_ren')" prop="projectContactName">
              <el-input v-model="form.projectContactName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('device_projectName_dialog.lian_xi_ren_dian_hua')" prop="projectContactPhone">
              <el-input v-model="form.projectContactPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        deviceId: '',
        projectContactName: '',
        projectContactPhone: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        projectContactName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        projectContactPhone: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.edit();
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.portalDeviceUpdate, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
          });
        }
      });
    },

    // getProjectInfo() {
    //   this.$getJSON(apis.locationInfo, { locationId: this.model.id }).then((res) => {
    //     const data = res.data || {};
    //     // console.log(this.model.data);
    //     this.$setFormatData(this.form, data);
    //     // 地址
    //     this.form.address = [];
    //     if (data.countryCode) {
    //       this.form.address.push(data.countryCode);
    //     }
    //     if (data.provinceCode) {
    //       this.form.address.push(data.provinceCode);
    //     }
    //     if (data.cityCode) {
    //       this.form.address.push(data.cityCode);
    //     }
    //   });
    // },
    initForm() {
      if (this.model.type === 'add') {
        return;
      }
      this.$setFormatData(this.form, this.model.data);
      this.form.projectContactPhone = '';
      // this.getProjectInfo();
    },
  },
  mounted() {
    this.initForm();
    // this.getLanguage();
  },
};
</script>

<style lang="scss">
.location-item-dialog {
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
}
</style>
